export const maps = {
  infoShadow: '0 0 20px 0 rgba(0,0,0,0.2)'
};
